import React, { useState, useEffect } from "react";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import DoneIcon from "@mui/icons-material/Done";
import { toast } from "react-toastify";
import moment from "jalali-moment";
import { useSetting } from "../../../../context/SettingContext";
import useFetch from "../../../../context/useFetch";
import { EmptyData, fixNumbers } from "../../../../utils";
import TableIconModal from "../../../shares/TableIconModal";
import MuiButton from "../../../shares/MuiButton";
import MuiSelect from "../../../shares/MuiSelect";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import AdminOrderCard from "../../shares/AdminOrderCard";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";

const statusList = [
  {
    name: "تغییر داده شده",
    value: true,
  },
  {
    name: "تغییر داده نشده",
    value: false,
  },
];

const AdminUpdateReturnedOrderListByCustomer = (props) => {
  const { defaultRingSize } = useSetting();
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);

  const [statusFilter, setStatusFilter] = useState("all");

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };

  const getOrderDetailsApi = useFetch({
    method: "get",
    url: `ReturnOrder_Service/${props.selectedRow?.id}/admin_get_return_order_item_detail_from_order`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    params: { admin_change_item: statusFilter },
    argFunc: (res) => {
      let tmp = {};
      res.results.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.admin_size_one_num);
        tmp[item.id].push(item.admin_size_two_num);
        tmp[item.id].push(item.admin_size_three_num);
        tmp[item.id].push(item.admin_size_four_num);
        tmp[item.id].push(item.admin_size_five_num);
        tmp[item.id].push(item.admin_size_six_num);
      });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();

  const updateOrderApi = useFetch({
    method: "patch",
    url: `Order_Service/${props.selectedRow?.id}/change_order_to_complete`,
    trigger: false,
    data: { state: "complete" },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);

      props.adminGetCustomerCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `ReturnOrderItem_Service/${selectedItem}/update_order_item`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getOrderDetailsApi.reFetch();
      props.adminGetCustomerCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      admin_size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      admin_size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      admin_size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      admin_size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      admin_size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      admin_size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
      admin_change_item: true,
    });
    updateDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  const admin_change_order_to_on_complete = () => {
    updateOrderApi.reFetch();
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getOrderDetailsApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<DeliveryDiningIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex justify-between items-center mb-2 pb-2 border-dashed	 border-b">
            <div>
              <span className="show-label">
                سند:{" "}
                <span className="show-value">
                  {" "}
                  {props.selectedRow?.unique_id}
                </span>
              </span>
              <span> / </span>
              <span className="show-label">
                مشتری:{" "}
                <span className="show-value mx-2 shrink-0">
                  {" "}
                  {props.selectedRow?.name}
                </span>
              </span>
            </div>
            {/* <div>
              <MuiButton
                onClick={admin_change_order_to_on_complete}
                variant="contained"
                icon={<DoneIcon />}
                color="primary"
                text={windowWidth > 768 ? "تحویل به مشتری" : "تحویل"}
                disabled={updateOrderApi.loading}
              />
            </div> */}
          </div>
          <div className="flex justify-between items-center mt-4">
            <span className="basis-1/2 md:basis-4/5 text-xs md:text-sm">
              برای مشاهده وضعیت سفارش ها فیلتر لازم را اعمال نمایید.
            </span>
            <div className="basis-1/2 md:basis-1/5">
              <MuiSelect
                size="small"
                inputLabel="وضعیت"
                labelId="status-label"
                id="status-select"
                label="status"
                menuItems={statusList}
                onChange={(e) => {
                  setStatusFilter(e.target.value);
                  getOrderDetailsApi.reFetch();
                }}
                value={statusFilter !== null ? statusFilter : "all"}
                defaultValue="all"
                haveAllOption={true}
              />
            </div>
          </div>
          <SizeTextGrid haveExtraCol have5Col />
          <div className="md:max-h-96 md:overflow-scroll">
            {currentOerdersDetail.results.length > 0 ? (
              <>
                {currentOerdersDetail.results.map((item, index) => {
                  return [
                    <AdminOrderCard
                      update_ring_item={update_ring_item}
                      showAcceptBtn
                      DontshowEditIconForAdmin
                      item={item}
                      move_date_to_parent={move_date_to_parent}
                      adminNeedDifference
                    >
                      <OrderCardLeftPartTemplate
                        nums={nums}
                        update_nums={update_nums}
                        dynamicMap={true}
                        data_item={item}
                        ringId={item.id}
                        adminDidntNeedCustomerRequestNum
                        adminNeedColor
                      />
                    </AdminOrderCard>,
                  ];
                })}
              </>
            ) : (
              <EmptyData text="نتیجه ای یافت نشد!" />
            )}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default AdminUpdateReturnedOrderListByCustomer;
